function fetchConfig(type = 'json') {
	return {
		method: 'POST',
		headers: {'Content-Type': 'application/json', 'Accept': `application/${type}`}
	};
}
function debounce(fn, delay) {
	let timeoutId;
	return function (...args) {
		clearTimeout(timeoutId);
		timeoutId = setTimeout(() => fn.apply(this, args), delay);
	};
}

function initFooterNewsletterValidation() {
  document.querySelectorAll('.footer__newsletter').forEach((form) => {
    if (form.dataset.validationBound === 'true') return;
    form.dataset.validationBound = 'true';

    const emailInput = form.querySelector('input[name="email"]');
    if (!emailInput) return;

    const errorEl = document.getElementById('newsletter-email-error');

    function syncErrorText() {
      if (!errorEl) return;
      errorEl.textContent =
        emailInput.getAttribute('aria-invalid') === 'true'
          ? emailInput.dataset.errorMessage || ''
          : '';
    }

    function revalidate() {
      emailInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    form.addEventListener('submit', (event) => {
      revalidate();

      if (emailInput.getAttribute('aria-invalid') !== 'true') return;

      event.preventDefault();
      event.stopImmediatePropagation();
      syncErrorText();
      emailInput.focus();
    });

    emailInput.addEventListener('blur', revalidate);

    emailInput.addEventListener('input', () => {
      if (!emailInput.closest('.footer__input-wrap')?.classList.contains('has-error')) return;
      revalidate();
    });

    document.addEventListener('change', (event) => {
      if (event.target === emailInput) syncErrorText();
    });
  });
}

window.initFooterNewsletterValidation = initFooterNewsletterValidation;

document.addEventListener('DOMContentLoaded', () => {
  initFooterNewsletterValidation();
});

document.addEventListener('click', function(event) {
	if (event.target.closest('.product-main__notify, .product-sticky__notify')) {
		const popup = document.getElementById('notify-popup');
		if (!popup) return;

		const variantId = document.querySelector('product-form input[name="id"]')?.value;
		const form = popup.querySelector('[data-notify-form]');
		if (form && variantId) form.dataset.variantId = variantId;

		// Reset success/error state from a previous open
		form?.querySelectorAll('[data-notify-default]').forEach(el => { el.hidden = false; });
		const prevSuccess = form?.querySelector('[data-notify-success]');
		if (prevSuccess) prevSuccess.hidden = true;
		const prevError = form?.querySelector('[data-notify-error]');
		if (prevError) prevError.hidden = true;

		popup.classList.add('is-open');
		popup.setAttribute('aria-hidden', 'false');
		document.body.classList.add('is-popup-open');
		const focusTarget = popup.querySelector('button[data-popup-close]') || popup.querySelector('.popup__dialog');
		window.requestAnimationFrame(() => focusTarget?.focus({ preventScroll: true }));
	}
});

document.addEventListener('click', function(event) {
	const closeTarget = event.target.closest('[data-popup-close]');
	if (closeTarget && closeTarget.closest('#cart-popup')) {
		const cartPopup = document.querySelector('#cart-popup');
		if (cartPopup) cartPopup.classList.remove('is-open');
		document.body.classList.remove('is-popup-open');
		return;
	}

	if (closeTarget && closeTarget.closest('#notify-popup')) {
		const notifyPopup = document.getElementById('notify-popup');
		if (notifyPopup) notifyPopup.classList.remove('is-open');
		notifyPopup?.setAttribute('aria-hidden', 'true');
		document.body.classList.remove('is-popup-open');
		return;
	}

});

document.addEventListener('change', function(event) {
	const giftToggle = event.target.closest('[data-cart-gift-toggle]');
	const messageToggle = event.target.closest('[data-cart-message-toggle]');

	if (giftToggle) {
		const container = giftToggle.closest('[data-cart-gift]');
		if (!container) return;
		const extra = container.querySelector('[data-cart-gift-extra]');
		const messageToggleEl = container.querySelector('[data-cart-message-toggle]');
		const messageField = container.querySelector('[data-cart-message-field]');
		const messageInput = messageField?.querySelector('textarea, input');
		const isChecked = giftToggle.checked;
		if (extra) extra.hidden = !isChecked;
		if (!isChecked) {
			if (messageToggleEl) messageToggleEl.checked = false;
			if (messageField) messageField.hidden = true;
			if (messageInput) messageInput.value = '';
		}
		return;
	}

	if (messageToggle) {
		const container = messageToggle.closest('[data-cart-gift]');
		if (!container) return;
		const messageField = container.querySelector('[data-cart-message-field]');
		const messageInput = messageField?.querySelector('textarea, input');
		if (messageField) messageField.hidden = !messageToggle.checked;
		if (!messageToggle.checked && messageInput) messageInput.value = '';
		return;
	}

	if (event.target.closest('input[name="purchase-type"], input[name="product-set"], [data-subscription-frequency]')) {
		updateProductPurchase(event.target);
	}
});

function formatMoney(cents) {
	const value = Math.round(cents);
	const format = window.moneyFormat || '${{amount}}';

	function withDelimiters(precision, thousands, decimal) {
		const fixed = (value / 100).toFixed(precision);
		const parts = fixed.split('.');
		const int = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
		return parts[1] ? int + decimal + parts[1] : int;
	}

	const out = format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, name) {
		switch (name) {
			case 'amount_no_decimals': return withDelimiters(0, ',', '.');
			case 'amount_with_comma_separator': return withDelimiters(2, '.', ',');
			case 'amount_no_decimals_with_comma_separator': return withDelimiters(0, '.', ',');
			case 'amount_with_apostrophe_separator': return withDelimiters(2, "'", '.');
			case 'amount_with_space_separator': return withDelimiters(2, ' ', ',');
			case 'amount_no_decimals_with_space_separator': return withDelimiters(0, ' ', ',');
			default: return withDelimiters(2, ',', '.');
		}
	});

	return value % 100 === 0 ? out.replace(/[.,]00(?!\d)/, '') : out;
}

function applyPercent(amount, percent) {
	if (!percent) return amount;
	return Math.round((amount * (100 - percent)) / 100);
}

function updateProductPurchase(origin) {
	const root = (origin && origin.closest('[data-product-purchase]')) || document.querySelector('[data-product-purchase]');
	if (!root) return;

	const frequencySelect = origin && origin.closest ? origin.closest('[data-subscription-frequency]') : null;
	if (frequencySelect) {
		const option = frequencySelect.options[frequencySelect.selectedIndex];
		const ownerRadio = frequencySelect.closest('.product-main__frequency-option')?.querySelector('input[name="purchase-type"]');
		if (option && ownerRadio) {
			ownerRadio.value = option.value;
			ownerRadio.dataset.discountPercent = option.dataset.discountPercent || '0';
			ownerRadio.checked = true;
		}
	}

	const setRadio = root.querySelector('input[name="product-set"]:checked');
	const qty = parseInt(setRadio?.dataset.qty, 10) || 1;
	const setBundleQtyRatio = parseInt(setRadio?.dataset.bundleQty, 10) || 1;
	const totalJars = setRadio?.dataset.bundleVariant ? qty + (qty * setBundleQtyRatio) : qty;

	root.querySelectorAll('.product-main__frequency-included-grid').forEach(function (grid) {
		let visibleCount = 0;
		grid.querySelectorAll('[data-perk-min-qty]').forEach(function (perk) {
			const minQty = parseInt(perk.dataset.perkMinQty, 10) || 1;
			const isVisible = totalJars >= minQty;
			perk.style.display = isVisible ? '' : 'none';
			if (isVisible) visibleCount++;
		});
		grid.dataset.visibleCount = visibleCount;
	});

	const unitPrice = parseInt(root.dataset.unitPrice, 10) || 0;

	function cardSubtotal(radio, radioQty) {
		const primaryUnitPrice = parseFloat(radio?.dataset.primaryUnitPrice) || unitPrice;
		const bundleUnitPrice = parseFloat(radio?.dataset.bundleUnitPrice) || 0;
		const bundleQtyRatio = parseInt(radio?.dataset.bundleQty, 10) || 1;
		return (primaryUnitPrice * radioQty) + (bundleUnitPrice * radioQty * bundleQtyRatio);
	}

	if (!unitPrice && !setRadio?.dataset.primaryUnitPrice) return;

	const setDiscount = parseFloat(setRadio?.dataset.discountPercent) || 0;
	const setTotal = applyPercent(cardSubtotal(setRadio, qty), setDiscount);

	root.querySelectorAll('input[name="product-set"]').forEach(function (radio) {
		const card = radio.closest('.product-main__set-item');
		if (!card) return;
		const cardQty = parseInt(radio.dataset.qty, 10) || 1;
		const cardDiscount = parseFloat(radio.dataset.discountPercent) || 0;
		const cardBefore = cardSubtotal(radio, cardQty);
		const cardAfter = applyPercent(cardBefore, cardDiscount);
		const bundleQtyRatio = parseInt(radio.dataset.bundleQty, 10) || 1;
		const cardTotalJars = radio.dataset.bundleVariant ? cardQty + (cardQty * bundleQtyRatio) : cardQty;

		const current = card.querySelector('[data-set-current]');
		const old = card.querySelector('[data-set-old]');
		const perJar = card.querySelector('[data-set-per-jar]');
		if (current) current.textContent = formatMoney(cardAfter);
		if (old) old.textContent = formatMoney(cardBefore);
		if (perJar) perJar.textContent = formatMoney(Math.floor(cardAfter / cardTotalJars));
	});

	root.querySelectorAll('.product-main__frequency-option').forEach(function (option) {
		const radio = option.querySelector('input[name="purchase-type"]');
		if (!radio) return;
		const planDiscount = radio.value === 'onetime' ? 0 : (parseFloat(radio.dataset.discountPercent) || 0);

		option.querySelectorAll('[data-subscribe-old]').forEach(function (el) { el.textContent = formatMoney(setTotal); });
		option.querySelectorAll('[data-subscribe-price]').forEach(function (el) { el.textContent = formatMoney(applyPercent(setTotal, planDiscount)); });
		option.querySelectorAll('[data-onetime-price]').forEach(function (el) { el.textContent = formatMoney(setTotal); });
	});

	const purchaseRadio = root.querySelector('input[name="purchase-type"]:checked');
	const isSubscription = purchaseRadio && purchaseRadio.value !== 'onetime';
	const planDiscount = isSubscription ? (parseFloat(purchaseRadio.dataset.discountPercent) || 0) : 0;
	const finalTotal = applyPercent(setTotal, planDiscount);

	document.querySelectorAll('[data-cart-total-price]').forEach(function (el) {
		el.textContent = formatMoney(finalTotal);
	});

	document.querySelectorAll('[data-product-qty-hidden]').forEach(function (input) {
		input.value = String(qty);
	});
	const sellingPlanInput = document.querySelector('[name="selling_plan"]');
	if (sellingPlanInput) sellingPlanInput.value = isSubscription ? purchaseRadio.value : '';
}

window.updateProductPurchase = updateProductPurchase;

document.addEventListener('DOMContentLoaded', function () {
	if (document.querySelector('[data-product-purchase]')) updateProductPurchase();
});

document.addEventListener('DOMContentLoaded', function() {
	const cartPopup = document.querySelector('#cart-popup');
	if (!cartPopup) return;

	new MutationObserver(function(mutations) {
		mutations.forEach(function(mutation) {
			if (mutation.attributeName === 'class' && cartPopup.classList.contains('is-open')) {
				if (typeof updateCartPopup === 'function') updateCartPopup();
			}
		});
	}).observe(cartPopup, { attributes: true });
});

const CART_MILESTONE_POP_MS = 400;

function cartMilestoneFillDurationMs(el) {
	const fill = el.querySelector('.cart-popup__milestones-fill');
	const raw = fill ? getComputedStyle(fill).transitionDuration.split(',')[0].trim() : '';
	const value = parseFloat(raw) || 0;
	return raw.endsWith('ms') ? value : value * 1000;
}

function cartMilestoneIconMarkup(type, reached) {
	if (reached) {
		return '<svg class="icon-check" viewBox="0 0 12 9" width="14" height="10" aria-hidden="true" focusable="false"><use href="#icon-check"></use></svg>';
	}
	return type === 'book'
		? '<svg class="icon-book" viewBox="0 0 14 14" width="14" height="14" aria-hidden="true" focusable="false"><use href="#icon-book"></use></svg>'
		: '<svg class="icon-shipping" viewBox="0 0 14 14" width="14" height="14" aria-hidden="true" focusable="false"><use href="#icon-shipping"></use></svg>';
}

function animateCartMilestones(el, oldFill, oldReached) {
	const fillEl = el.querySelector('.cart-popup__milestones-fill');
	const newFill = parseFloat(el.style.getPropertyValue('--cart-milestones-progress')) || 0;
	const durationMs = cartMilestoneFillDurationMs(el);
	const badges = Array.from(el.querySelectorAll('.cart-popup__milestones-badge'));

	const newlyReached = badges.filter(badge => {
		const isReachedNow = !!badge.querySelector('.icon-check');
		return isReachedNow && !oldReached.get(badge.dataset.milestoneType);
	});

	if (newFill === oldFill && !newlyReached.length) return;

	newlyReached.forEach(badge => {
		const icon = badge.querySelector('.icon-check, .icon-book, .icon-shipping');
		if (icon) icon.outerHTML = cartMilestoneIconMarkup(badge.dataset.milestoneType, false);
	});

	const popBadge = badge => {
		const icon = badge.querySelector('.icon-book, .icon-shipping');
		if (icon) icon.outerHTML = cartMilestoneIconMarkup(badge.dataset.milestoneType, true);
		badge.classList.add('cart-popup__milestones-badge--pop');
	};

	const playConfettiIfComplete = delayMs => {
		const reachedTypes = new Set(badges.filter(b => oldReached.get(b.dataset.milestoneType)).map(b => b.dataset.milestoneType));
		newlyReached.forEach(b => reachedTypes.add(b.dataset.milestoneType));
		const allReached = badges.length > 0 && badges.every(b => reachedTypes.has(b.dataset.milestoneType));
		if (newlyReached.length && allReached && typeof window.LaylConfetti?.play === 'function') {
			setTimeout(() => window.LaylConfetti.play(), delayMs);
		}
	};

	el.style.setProperty('--cart-milestones-progress', `${newFill}%`);

	if (!fillEl || !(durationMs > 0)) {
		newlyReached.forEach(popBadge);
		playConfettiIfComplete(CART_MILESTONE_POP_MS);
		return;
	}

	fillEl.style.transition = 'none';
	fillEl.style.width = `${oldFill}%`;

	const span = newFill - oldFill;
	const popped = new Set();
	const start = performance.now();

	function step(now) {
		const t = Math.min(1, (now - start) / durationMs);
		const eased = 1 - Math.pow(1 - t, 3);
		const current = oldFill + span * eased;
		fillEl.style.width = `${current}%`;

		newlyReached.forEach(badge => {
			const type = badge.dataset.milestoneType;
			if (popped.has(type)) return;
			const position = parseFloat(badge.style.getPropertyValue('--cart-milestone-position')) || 0;
			if (span >= 0 ? current >= position : current <= position) {
				popped.add(type);
				popBadge(badge);
			}
		});

		if (t < 1) {
			requestAnimationFrame(step);
		} else {
			fillEl.style.width = '';
			fillEl.style.transition = '';
			playConfettiIfComplete(CART_MILESTONE_POP_MS);
		}
	}
	requestAnimationFrame(step);
}

async function removeOrphanedProtectionItem(popup) {
	const variantId = parseInt(popup?.dataset.protectionVariant, 10);
	if (!variantId) return;
	try {
		const cartData = await fetch('/cart.js').then(r => r.json());
		const protectionItem = cartData.items.find(item => item.variant_id === variantId);
		if (!protectionItem) return;

		await fetch(window.routes.cart_change_url, {
			...fetchConfig(),
			body: JSON.stringify({ id: protectionItem.key, quantity: 0 })
		});
	} catch (error) {
		console.error('Protection cleanup error:', error);
	}
}

let cartPopupUpdatePromise = null;

function updateCartPopup(isCleanupRetry = false) {
	if (!isCleanupRetry && cartPopupUpdatePromise) return cartPopupUpdatePromise;
	const run = runCartPopupUpdate(isCleanupRetry);
	if (isCleanupRetry) return run;
	cartPopupUpdatePromise = run.finally(() => { cartPopupUpdatePromise = null; });
	return cartPopupUpdatePromise;
}

async function runCartPopupUpdate(isCleanupRetry) {
	try {
		const params = new URLSearchParams(window.location.search);
		params.set('_t', Date.now());
		const response = await fetch(`/?${params.toString()}`, { cache: 'no-store' });
		const html = await response.text();
		const doc = new DOMParser().parseFromString(html, 'text/html');

		const currentPopup = document.querySelector('#cart-popup');
		const fetchedPopup = doc.querySelector('#cart-popup');
		if (!fetchedPopup || !currentPopup) return;

		if (!isCleanupRetry && fetchedPopup.dataset.cartRealCount === '0' && fetchedPopup.dataset.protectionInCart === 'true') {
			await removeOrphanedProtectionItem(fetchedPopup);
			await updateCartPopup(true);
			return;
		}

		const milestonesBefore = currentPopup.querySelector('.cart-popup__milestones');
		const milestonesOldFill = milestonesBefore
			? parseFloat(milestonesBefore.style.getPropertyValue('--cart-milestones-progress')) || 0
			: 0;
		const milestonesOldReached = new Map();
		milestonesBefore?.querySelectorAll('.cart-popup__milestones-badge').forEach(badge => {
			milestonesOldReached.set(badge.dataset.milestoneType, !!badge.querySelector('.icon-check'));
		});

		const currentTitle = currentPopup.querySelector('.cart-popup__title');
		const fetchedTitle = fetchedPopup.querySelector('.cart-popup__title');
		if (currentTitle && fetchedTitle) currentTitle.innerHTML = fetchedTitle.innerHTML;

		const realCount = fetchedPopup.dataset.cartRealCount;
		if (realCount !== undefined) {
			currentPopup.dataset.cartRealCount = realCount;
			setCartCountDisplay(realCount);
		}

		if (fetchedPopup.dataset.protectionVariant !== undefined) {
			currentPopup.dataset.protectionVariant = fetchedPopup.dataset.protectionVariant;
		}
		if (fetchedPopup.dataset.protectionInCart !== undefined) {
			currentPopup.dataset.protectionInCart = fetchedPopup.dataset.protectionInCart;
		}

		const currentHeaderInfo = currentPopup.querySelector('.cart-popup__header-info');
		const fetchedReserved = fetchedPopup.querySelector('.cart-popup__reserved');
		const currentReserved = currentPopup.querySelector('.cart-popup__reserved');
		if (fetchedReserved && !currentReserved) {
			currentHeaderInfo?.appendChild(fetchedReserved.cloneNode(true));
		} else if (!fetchedReserved && currentReserved) {
			currentReserved.remove();
		}

		const currentMain = currentPopup.querySelector('.cart-popup__main');
		const fetchedMain = fetchedPopup.querySelector('.cart-popup__main');
		if (currentMain && fetchedMain) {
			const currentContent = currentMain.querySelector('.cart-popup__list');
			const fetchedContent = fetchedMain.querySelector('.cart-popup__list');
			if (currentContent && fetchedContent) {
				currentContent.outerHTML = fetchedContent.outerHTML;
			} else if (!currentContent && fetchedContent) {
				currentMain.appendChild(fetchedContent);
			}
		}

		const milestonesAfter = currentPopup.querySelector('.cart-popup__milestones');
		if (milestonesAfter) {
			animateCartMilestones(milestonesAfter, milestonesOldFill, milestonesOldReached);
		}

		const currentCheckout = currentPopup.querySelector('.cart-popup__checkout');
		const fetchedCheckout = fetchedPopup.querySelector('.cart-popup__checkout');
		if (currentCheckout && fetchedCheckout) currentCheckout.innerHTML = fetchedCheckout.innerHTML;

		const currentFooter = currentPopup.querySelector('.cart-popup__footer');
		const fetchedFooter = fetchedPopup.querySelector('.cart-popup__footer');
		if (currentFooter) {
			currentFooter.hidden = !fetchedFooter || fetchedFooter.hidden;
		}

		const isEmpty = fetchedPopup.classList.contains('popup--cart-empty');
		currentPopup.classList.toggle('popup--cart-empty', isEmpty);
		currentPopup.querySelector('.cart-popup')?.classList.toggle('cart-popup--empty', isEmpty);

	} catch (error) {
		console.error('Cart popup content update error:', error);
	}
}

function setCartCountDisplay(count) {
	document.querySelectorAll('[data-cart-count]').forEach(element => {
		const text = element.textContent || '';
		element.textContent = text.includes('(')
			? text.replace(/\(\s*\d+\s*\)/, `(${count})`)
			: `${text.trim()} (${count})`.trim();
	});
}

function updateCartCount() {
	// /cart.js counts bonus lines as items; only the rendered section knows better.
	const count = document.querySelector('#cart-popup')?.dataset.cartRealCount;
	if (count !== undefined) setCartCountDisplay(count);
}

// Klaviyo back-in-stock subscription
document.addEventListener('submit', async function(event) {
	const form = event.target.closest('[data-notify-form]');
	if (!form) return;

	event.preventDefault();

	const errorEl = form.querySelector('[data-notify-error]');
	const successEl = form.querySelector('[data-notify-success]');
	const hideDefaults = () => form.querySelectorAll('[data-notify-default]').forEach(el => { el.hidden = true; });

	const showError = (msg) => {
		hideDefaults();
		if (successEl) successEl.hidden = true;
		if (errorEl) { errorEl.textContent = msg; errorEl.hidden = false; }
	};

	if (errorEl) errorEl.hidden = true;

	const publicApiKey = window.klaviyoConfig?.publicApiKey;
	if (!publicApiKey) {
		showError('Subscription service is not configured. Please try again later.');
		return;
	}

	const variantId = form.dataset.variantId;
	if (!variantId) {
		showError('Could not determine the product variant. Please reload the page and try again.');
		return;
	}

	const email = form.querySelector('input[name="email"]')?.value?.trim();
	if (!email) return;

	const phoneInput = form.querySelector('[data-phone-input]');
	const phone = phoneInput?.iti ? phoneInput.iti.getNumber() : phoneInput?.value?.trim();

	const submitBtn = form.querySelector('.popup-notify__submit');
	if (submitBtn) submitBtn.disabled = true;

	const channels = ['EMAIL'];
	if (phone) channels.push('SMS');

	const payload = {
		data: {
			type: 'back-in-stock-subscription',
			attributes: {
				channels,
				profile: {
					data: {
						type: 'profile',
						attributes: {
							email,
							...(phone && { phone_number: phone })
						}
					}
				}
			},
			relationships: {
				variant: {
					data: {
						type: 'catalog-variant',
						id: `$shopify:::$default:::${variantId}`
					}
				}
			}
		}
	};

	try {
		const response = await fetch(
			`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(publicApiKey)}`,
			{
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'revision': '2023-12-15'
				},
				body: JSON.stringify(payload)
			}
		);

		if (!response.ok) {
			const errorText = await response.text().catch(() => response.status);
			throw new Error(`Klaviyo API ${response.status}: ${errorText}`);
		}

		const cfg = window.klaviyoConfig?.notify || {};
		if (successEl) {
			const titleEl = successEl.querySelector('[data-notify-success-title]');
			const textEl = successEl.querySelector('[data-notify-success-text]');
			if (titleEl) titleEl.textContent = cfg.successTitle || "You're on the list!";
			if (textEl) textEl.textContent = cfg.successText || "We'll notify you as soon as this item is back in stock.";
			hideDefaults();
			if (errorEl) errorEl.hidden = true;
			successEl.hidden = false;
		}

		form.querySelector('input[name="email"]').value = '';
		if (phoneInput) phoneInput.value = '';

	} catch (error) {
		console.error('Klaviyo back-in-stock error:', error);
		showError('Something went wrong. Please try again.');
	} finally {
		if (submitBtn) submitBtn.disabled = false;
	}
});

// Klaviyo newsletter subscription (footer form)
document.addEventListener('submit', async function(event) {
	const form = event.target.closest('[data-newsletter-form]');
	if (!form) return;

	event.preventDefault();
	event.stopImmediatePropagation();

	const emailInput = form.querySelector('input[name="email"]');
	const errorEl = form.querySelector('[id="newsletter-email-error"]');
	const successEl = form.querySelector('[data-newsletter-success]');
	const submitBtn = form.querySelector('[type="submit"]');

	const showError = (msg) => {
		if (errorEl) { errorEl.textContent = msg; }
		if (emailInput) { emailInput.setAttribute('aria-invalid', 'true'); emailInput.focus(); }
	};
	const clearError = () => {
		if (errorEl) errorEl.textContent = '';
		if (emailInput) emailInput.removeAttribute('aria-invalid');
	};

	const email = emailInput?.value?.trim();
	if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
		showError(emailInput?.dataset.errorMessage || 'Please enter a valid email address');
		return;
	}

	clearError();

	const publicApiKey = window.klaviyoConfig?.publicApiKey;
	const listId = window.klaviyoConfig?.newsletter?.listId;

	if (!publicApiKey || !listId) {
		console.warn('Klaviyo newsletter: public API key or list ID not configured');
		showError('Subscription service is not configured. Please try again later.');
		return;
	}

	if (submitBtn) submitBtn.disabled = true;

	const payload = {
		data: {
			type: 'subscription',
			attributes: {
				custom_source: 'Footer Newsletter',
				profile: {
					data: {
						type: 'profile',
						attributes: { email }
					}
				}
			},
			relationships: {
				list: {
					data: { type: 'list', id: listId }
				}
			}
		}
	};

	try {
		const response = await fetch(
			`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(publicApiKey)}`,
			{
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'revision': '2023-12-15'
				},
				body: JSON.stringify(payload)
			}
		);

		if (!response.ok) {
			const errorText = await response.text().catch(() => String(response.status));
			throw new Error(`Klaviyo API ${response.status}: ${errorText}`);
		}

		if (emailInput) emailInput.value = '';
		if (successEl) {
			successEl.textContent = successEl.dataset.successMessage || window.klaviyoConfig?.newsletter?.successMessage || 'Thank you for subscribing!';
			successEl.hidden = false;
		}

	} catch (error) {
		console.error('Klaviyo newsletter error:', error);
		showError('Something went wrong. Please try again.');
	} finally {
		if (submitBtn) submitBtn.disabled = false;
	}
});